/**
 * @brief 공간안내 슬라이드
 * @details
 * @author hyekyoungKang
 * @date 2024-06-05
 * @version 0.0.1
 */

import React, { useRef, useState } from "react";
import styles from "./MembershipSingleSlide.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; // Import Slick CSS
import "slick-carousel/slick/slick-theme.css"; // Import Theme CSS
import PreviousArrowSvg from "./../../../assets/images/PreviousArrow.svg";
import NextArrowSvg from "./../../../assets/images/NextArrow.svg";

const MembershipSingleSlide = () => {
  const datas = [
    {
      id: 1,
      img: "./assets/images/office_single01",
    },
    {
      id: 2,
      img: "./assets/images/office_single02",
    },
  ];

  const [index, setIndex] = useState(0);
  const sliderRef = useRef(null);

  const previous = () => {
    if (index > 0) {
      sliderRef.current.slickPrev();
    }
    console.log("클릭-");
  };

  const next = () => {
    if (index < datas.length - 1) {
      sliderRef.current.slickNext();
    }

    console.log("클릭");
  };

  const beforeChange = (prev, next) => {
    setIndex(next);
  };

  const settings = {
    infinite: true,
    autoplay: false,
    variableWidth: true, //width 인식이 안될때 ture로 해주기
    // 슬라이드 변경 시간
    // speed: 2000,
    // 자동 재생 유지 시간
    // autoplaySpeed: 2000,
    // cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    beforeChange: beforeChange,
    arrow: false, //화살표
    dots: false, //도트 버튼
  };

  return (
    <div className={styles.container}>
      {/* 버튼 */}
      <button
        className={styles.button__pre}
        onClick={previous}
        disabled={index === 0}
      >
        <PreviousArrowSvg />
      </button>
      <button
        onClick={next}
        className={styles.button__next}
        disabled={index === datas.length - 1}
      >
        <NextArrowSvg />
      </button>
      {/* 버튼 끝 */}
      {/* 슬라이드 */}
      <Slider {...settings} ref={sliderRef}>
        {datas.map((item, idx) => (
          <div className={styles.slideCard} key={idx}>
            <picture className={styles.slideCard__imgBox}>
              <source
                srcSet={`${item.img}.webp`} // webp 이미지 소스로 설정.
                type="image/webp"
              />
              <img
                className={styles.slideCard__img}
                src={item}
                srcSet={`${item.img}.jpg`} // JPG 이미지 소스로 설정
                alt=""
              />
            </picture>
          </div>
        ))}
      </Slider>
      {/* 슬라이드 끝 */}
    </div>
  );
};

export default MembershipSingleSlide;
